//
// locale_th.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/th.json';
import localeData from "react-intl/locale-data/th.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_th.js